module.exports = __webpack_public_path__ + "static/media/11NEPAD11.0f063e96.jpg";